(() => {
  function init() {
    const root = document.querySelector('.rd-hero');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.rd-form');
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('.rd-error');
    const token = form.dataset.offer;
    const parseProps = item => { try { return JSON.parse(item.properties?._fudge || '{}'); } catch (_) { return {}; } };
    const giftInCart = cart => cart.items.some(item => Number(item.variant_id) === Number(form.dataset.gift) && parseProps(item).offer === token && parseProps(item).slot === 'goodie');
    const track = root.querySelector('.rd-gallery-track');
    const thumbs = [...root.querySelectorAll('.rd-thumb')];
    const slides = [...root.querySelectorAll('.rd-slide')];
    let index = 0;
    const go = i => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
    root.querySelector('.rd-gallery-prev').addEventListener('click', () => go((index - 1 + slides.length) % slides.length));
    root.querySelector('.rd-gallery-next').addEventListener('click', () => go((index + 1) % slides.length));
    track.addEventListener('scroll', () => {
      index = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    window.__fudgeDebug?.command('Raumduft Galeriebild', value => { go(Number(value)); return { image: index + 1 }; });
    window.__fudgeDebug?.action('Raumduft Gratis-Zubehör ansehen', () => go(slides.length - 1));
    const sticky = document.querySelector('.rd-sticky');
    if (sticky) {
      new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || root.getBoundingClientRect().bottom > 0; }, { threshold: 0 }).observe(root);
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled || form.dataset.busy) return;
      form.dataset.busy = 'true';
      const oldLabel = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Wird hinzugefügt …';
      error.textContent = '';
      try {
        const base = window.Shopify?.routes?.root || '/';
        const cartRes = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!cartRes.ok) throw new Error('Der Warenkorb ist gerade nicht erreichbar. Bitte versuche es erneut.');
        const cart = await cartRes.json();
        const props = slot => ({ _fudge: JSON.stringify({ offer: token, slot }) });
        const items = [{ id: Number(form.dataset.variant), quantity: 1, properties: props('set') }];
        if (!giftInCart(cart)) items.push({ id: Number(form.dataset.gift), quantity: 1, properties: props('goodie') });
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'], sections_url: location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Das Set konnte nicht hinzugefügt werden. Bitte prüfe den Warenkorb.');
        if (typeof window.upcartOpenCart === 'function') {
          for (const id of ['cart-icon-bubble', 'mobile-cart-icon-bubble']) {
            const target = document.getElementById(id);
            const html = data.sections?.[id];
            if (target && html) {
              const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
              if (section) target.innerHTML = section.innerHTML;
            }
          }
          if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
          window.upcartOpenCart();
        } else {
          const miniCart = document.querySelector('mini-cart');
          if (miniCart && data.sections?.['mini-cart']) miniCart.renderContents(data);
          else error.textContent = 'Zum Warenkorb hinzugefügt. Du kannst ihn oben über das Warenkorbsymbol öffnen.';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'raumduft-set', cartData: data });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
      } catch (e) {
        console.error('[Raumduft] add failed', e);
        error.textContent = e.message || 'Das Hinzufügen hat nicht geklappt. Bitte versuche es erneut.';
      } finally {
        delete form.dataset.busy;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = oldLabel;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
